import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { X } from 'lucide-react';

// Shared Drawer Header Component
type DrawerHeaderProps = {
  title: string;
  icon?: ReactNode;
  onClose?: () => void;
  className?: string;
};

export function DrawerHeader({ title, icon, onClose, className }: DrawerHeaderProps) {
  return (
    <div className={`flex items-center justify-between p-3 border-b ${className || ''}`}>
      <div className="flex items-center gap-2">
        {icon}
        <h2 className="tracking-tight text-base font-medium text-foreground/80">{title}</h2>
      </div>
      {onClose && (
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}

// Shared Drawer Content Component
type DrawerContentProps = {
  children: ReactNode;
  className?: string;
};

export function DrawerContent({ children, className }: DrawerContentProps) {
  return (
    <ScrollArea className={`h-[calc(100%-48px)] p-3 ${className || ''}`}>
      {children}
    </ScrollArea>
  );
}

// Shared Drawer Footer Component
type DrawerFooterProps = {
  children: ReactNode;
  className?: string;
};

export function DrawerFooter({ children, className }: DrawerFooterProps) {
  return (
    <div className={`p-3 border-t bg-muted/5 ${className || ''}`}>
      {children}
    </div>
  );
}

